import * as React from 'react';
import Icon from '@cx-web/components/primitives/icon';
import { type ILabelActions } from '@cx-web/feature-i18n';

import styles from './MiniMyOC.module.css';

interface LoggedInMiniMyOCProps {
  labelActions: ILabelActions;
  onLogout?: () => void;
  showProfileLink?: boolean;
  siteConfig?: { subscriptions?: { enabled?: boolean } };
  type: 'desktop' | 'burgerTop' | 'pageButton';
}

const UserIcon: React.FC = () => <Icon data-testid="user-icon" icon="User" />;

const LoggedInMiniMyOC: React.FC<LoggedInMiniMyOCProps> = ({
  labelActions,
  onLogout,
  showProfileLink,
  siteConfig,
  type,
}) => {
  const handleLogout = (): void => {
    onLogout?.();
  };

  if (type === 'desktop') {
    return (
      <div className={styles.myOC} data-testid="mini-myoc">
        <span className={styles.myOCIconWrapper}>
          <UserIcon />
          <span className={styles.indicator}> &#x25BE;</span>
        </span>
        <div className={styles.myOCDropdown} data-testid="myoc-dropdown">
          <span className={styles.upArrow} />
          <div className={styles.myOCTitle} data-testid="myoc-title">
            {labelActions.get('MY_ODDSCHECKER')}
          </div>
          {showProfileLink && (
            <a href="myoddschecker/profile" title={labelActions.get('PROFILE')}>
              <div className={styles.myOCRow} data-testid="myoc-profile">
                {labelActions.get('PROFILE')}
              </div>
            </a>
          )}
          <a href="myoddschecker/settings" title={labelActions.get('SETTINGS')}>
            <div className={styles.myOCRow} data-testid="myoc-settings">
              {labelActions.get('SETTINGS')}
            </div>
          </a>
          {siteConfig?.subscriptions?.enabled && (
            <a
              href="https://app.prosperstack.com/p/portal/acct_C26RDWQxovsqswzDoFxz6get"
              title={labelActions.get('SUBSCRIPTIONS')}
            >
              <div className={styles.myOCRow} data-testid="myoc-subscriptions">
                {labelActions.get('SUBSCRIPTIONS')}
              </div>
            </a>
          )}
          <div
            className={[styles.myOCRow, styles.lastRow].join(' ')}
            data-testid="logout-button"
            onClick={handleLogout}
          >
            {labelActions.get('LOG_OUT')}
          </div>
        </div>
      </div>
    );
  }

  if (type === 'burgerTop' || type === 'pageButton') {
    return (
      <a href="myoddschecker/profile" title={labelActions.get('MY_ODDSCHECKER')}>
        <span className={styles.myOCIconWrapper}>
          <UserIcon />
        </span>
      </a>
    );
  }

  return null;
};

export default LoggedInMiniMyOC;
